import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomLogisticsTable from "../../CustomLogisticsTable";
import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
import updateIcon from "../../../../../Assets/icons/check-circle (8) 1.svg";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import AllotQuantity from "./AllotQuantity";
import StockHistory from "./StockHistory";
import Loader from "../../../../customComponents/CustomLoader";

const StockOutDetails = () => {
  const [poApprovalEdit, setPoApprovalEdit] = useState([]);
  const [poId, setPoId] = useState(0);
  const [formData, setFormData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [stockinData, setStockinData] = useState([]);
  const stockinDrawerRadios = [
    { value: "inventory", label: "Stock In" },
    { value: "shortage", label: "Received Shortage" },
    { value: "damaged", label: "Defective Return" },
  ];
  const [loading, setLoading] = useState(true);
  const [showroomIdVal, setShowroomIdVal] = useState();
  const [serialDrawer, setSerialDrawer] = useState(false);
  const [isSerailDrawerOpen, setIsSerialDrawerOpen] = useState(false);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};
  const POID = data?.po_id;
  const [allotData, setAllotData] = useState([]);
  console.log("allotdata<><><>", allotData);

  useEffect(() => {
    fetchPoApprovalDetailsEdit();
  }, []);

  const fetchPoApprovalDetailsEdit = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(
        `/purchaseorder/edit/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data;

      const showroomId = response.data.data.showroom_id;
      console.log(showroomId, "showroomId");
      setShowroomIdVal(showroomId);

      console.log(fetchedData, "FETCHEDDATA");
      setPoApprovalEdit(fetchedData);
      const poIdVal = response.data.data.po_id;
      console.log(poIdVal, "POVALID");
      setPoId(poIdVal);

      console.log(formData, "depatartment DATA");
    } catch (error) {
      console.log(error);
    }
    finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchPoStockout();
  }, []);

  const fetchPoStockout = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/podetails/list",
        {
          orderBy: "po_details_id desc",
          page,
          pageSize,
          listType: "stockout",
          po_id: POID,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        // "Sr No.": index + 1 + page * pageSize
      }));
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);
      setStockinData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPoStockout(newPage);
  };

  const PO_TABLE_HEADERS = [
    "Name",
    "Logistic Type",
    "Product Name",
    "Sub Product Name",
    "Make",
    "Vendor Name",

    "Variant",
    "Accepted Qty",
    "Alloted Qty.",

    "Price",
    "Total Amount",
    "Action",
  ];

  const poKeyMapping = {
    Name: "name",
    "Logistic Type": "itemtypename",
    "Product Name": "product_name",
    "Sub Product Name": "subproduct_name",
    Make: "make_name",
    "Vendor Name": "companyname",
    Variant: "variant_name",

    "Alloted Qty.": "allotedqty",
    "Accepted Qty": "accepted_qty",
    Price: "rate",
    "Total Amount": "totalprice",
    Action: [
      // { type: "view", icon: eyeIcon, label: "View" },
      { type: "allot", icon: plusIcon, label: "allot" },
    ],
  };
  const toggleSerialDrawer = () => {
    console.log("isSerailDrawerOpen", isSerailDrawerOpen);

    setIsSerialDrawerOpen((prevState) => !prevState);
  };

  const handleAllotDrawer = (rowData) => {
    console.log("rowData>>", rowData);
    setAllotData(rowData);
    setSerialDrawer(true);
    toggleSerialDrawer();
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="">
            <div
              style={{
                paddingBottom: "35px",
                borderBottom: "1px solid lightgray",
                padding: "35px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span
                  style={{
                    fontWeight: "300",
                    fontSize: "12px",
                    paddingBottom: "5px",
                    color: "gray",
                    paddingLeft: "15px",
                  }}
                >
                  Sales / Stock-Out / Stock-Out Details
                </span>
                <div className="backbutton" onClick={() => navigate(-1)}>
                  <img src={backicon} alt="back" />
                  <span className="backbtntitleDetails">
                    {" "}
                    Stock-Out Details
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div className="">
                <h5
                  style={{ paddingLeft: "55px" }}
                  className="mt-2 mb-2 header-details"
                >
                  Details
                </h5>
                <div
                  className="detail-grid"
                  style={{
                    paddingBottom: "30px",
                    borderBottom: "1px solid lightgray",
                    paddingLeft: "57px",
                    paddingTop: "15px",
                  }}
                >
                  <div className="details-item">
                    <span className="details-label">PO Number</span>
                    <span className="details-value">
                      {" "}
                      {poApprovalEdit.po_number}{" "}
                    </span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">PO Date</span>
                    <span className="details-value">
                      {poApprovalEdit.po_date}{" "}
                    </span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Purchase Order Type</span>
                    <span className="details-value">
                      {poApprovalEdit.po_type}{" "}
                    </span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Vendor Name</span>
                    <span className="details-value">
                      {poApprovalEdit.companyname}{" "}
                    </span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Ref. No.</span>
                    <span className="details-value">
                      {poApprovalEdit.reference_no}{" "}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">Department</span>
                    <span className="details-value">
                      {poApprovalEdit.department_name}{" "}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">Payment Term</span>
                    <span className="details-value">
                      {poApprovalEdit.payment_term_name}{" "}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">Payment Type</span>
                    <span className="details-value">
                      {poApprovalEdit.payment_mode}{" "}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">PO Expected Date</span>
                    <span className="details-value">
                      {poApprovalEdit.po_expected_date}{" "}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">Payment Date</span>
                    <span className="details-value">
                      {poApprovalEdit.payment_date}{" "}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">Total</span>
                    <span className="details-value">
                      {poApprovalEdit.total}{" "}
                    </span>
                  </div>
                </div>

                {serialDrawer && (
                  <Drawer
                    size={700}
                    open={isSerailDrawerOpen}
                    onClose={toggleSerialDrawer}
                    direction="right"
                    className="bla bla bla"
                  >
                    <div style={{ padding: "30px" }}>
                      {allotData?.accepted_qty - allotData?.allotedqty > 0 && (
                        <div style={{ paddingTop: "14px" }}>
                          <AllotQuantity
                            fetchPoStockout={fetchPoStockout}
                            allotData={allotData}
                            isSubmit={true}
                            isSerailDrawerOpen={isSerailDrawerOpen}
                            toggleSerialDrawer={toggleSerialDrawer}
                          />
                        </div>
                      )}
                      <div style={{ paddingTop: "14px" }}>
                        <StockHistory
                          allotData={allotData}
                          isSubmit={false}
                          isHistoryTable={true}
                          isSerailDrawerOpen={isSerailDrawerOpen}
                        />
                      </div>
                    </div>
                  </Drawer>
                )}

                <div style={{ paddingTop: "14px" }}>
                  <CustomLogisticsTable
                    data={stockinData}
                    headers={PO_TABLE_HEADERS}
                    keyMapping={poKeyMapping}
                    itemsPerPage={10}
                    onPageChange={handlePageChange}
                    updateIcon={updateIcon}
                    handleAllot={handleAllotDrawer}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockOutDetails;
